import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/admin/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
        <img src="/logo_wide.webp" alt="RED EYE" className="w-36 mx-auto mb-8" />
        <h1 className="font-heading font-black uppercase text-2xl text-[#F0EDEA] text-center mb-6">New Password</h1>
        {error && <div className="text-[#FF4550] text-sm mb-4">{error}</div>}
        <input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="New password" className="w-full bg-[#1C1C1C] border border-[#333] rounded-xl h-12 px-4 text-[#F0EDEA] focus:border-[#E60000] outline-none mb-6" />
        <button type="submit" className="btn-skew btn-primary w-full"><span>Update Password</span></button>
        <Link to="/admin/login" className="block text-center text-[#A8A2A0] text-sm mt-4 hover:text-[#E60000]">Back to login</Link>
      </form>
    </div>
  );
}
